export default __webpack_public_path__ + "_/images/bookmaker-stamp-366fe98b8e1177177ebdb11294b8a63bf78fedd6190891312c083239a4df1894.png";